import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { debounce } from '../../../helpers/common'
import { Input } from '../../html/input'
import { changeSearchTerm } from './store/slice'

export const SearchBox = () => {
  const dispatch = useDispatch()

  const [textSearch, setTextSearch] = useState('')

  const setSearchTerm = useCallback(
    debounce((payload) => {
      dispatch(changeSearchTerm(payload))
    }, 300),
    [],
  )

  const handleChange = (e) => {
    const value = e.target.value
    setTextSearch(value)
    setSearchTerm(value.trim())
  }

  return (
    <Input
      noControl
      containerStyle={{
        flex: 1,
      }}
      placeHolder="library.savePortfolio.SEARCH_PORTFOLIO"
      type="text"
      value={textSearch}
      onChange={handleChange}
    />
  )
}
